import styles from './DocumentHeaderNavigation.scss';
import icons from 'styles/icons/icons.scss';
import QuickMenu from 'common/components/QuickMenu/QuickMenu';

export const DocumentHeaderNavigation = props => {
    function goBack(e) {
        e.preventDefault();
        props.goBack();
    }

    if (props.noHeader) {
        return null;
    }

    const menu = props.options
        ? (
            <QuickMenu headerText="Actions" theme="documentView" options={props.options} />
        ) : null;

    return (
        <section className={styles.documentHeaderNavigation} data-cy="DocumentHeaderNavigation">
            { props.goBack &&
                <nav className={styles.backButtonArea}>
                    <span className={icons.materialIcons}>chevron_left</span>
                    <a href="#" onClick={goBack} data-cy="DocumentHeaderNavigation-Back">Back</a>
                </nav>
            }
            <nav className={styles.titleArea}>
                <span className={icons.materialIcons}>chevron_left</span>
                <span data-cy="DocumentHeaderNavigation-name">{props.document.name}</span>
                <span className={icons.materialIcons}>chevron_right</span>
            </nav>
            { menu &&
                <div className={styles.actionsArea} data-cy="DocumentHeaderNavigation-menu">
                    { menu }
                </div>
            }
        </section>
    );
};

export default DocumentHeaderNavigation;
